import { PageCardTransactionApiResponse } from './ApiResponse';
import { PageCardTransaction } from './CardTransaction';
import { PageCardTransactionInformation } from './Information';
import { PageCardTransactionsOverview } from './Overview';

export { PageCardTransactionsOverview } from './Overview';

export const CARD_TRANSACTIONS = {
  CardTransactions: PageCardTransactionsOverview,
  CardTransactionSection: PageCardTransaction,
  CardTransactionInformation: PageCardTransactionInformation,
  CardTransactionApiResponse: PageCardTransactionApiResponse,
} as const;
